module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-16-30d337eea6a5143fe330902a1d56c5b9.svg";